(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('fileService', fileService);

	function fileService($http, assetCommonConfig, uriUtility) {

		function getFileAsync(fileId, cancellationToken) {
			return $http.get(uriUtility.fromPattern(assetCommonConfig.assetServiceBaseUri + 'files/{id}', { id: fileId }), { timeout: cancellationToken })
				.then(function(response) { return response.data; });
		}

		return {
			getFileAsync: getFileAsync
		};
	}
	fileService.$inject = ['$http', 'assetCommonConfig', 'uriUtility'];
})();